// Generated from the exact 1.3 (build 13) bundled catalog. Do not edit by hand.
export const LEGACY_1_3_COURSE_IDS = new Set(["00187-001-2000637","00191-001-2000759","00191-001-2000763","00231-001-2000746","00235-001-2000583","00262-001-2000599","00295-001-2000599","00350-001-2000636","00375-001-2000414","00401-001-2000636","00401-002-2000636","00401-003-2000636","00401-004-2000636","00403-001-2000414","00407-001-2000636","00407-002-2000636","00407-003-2000636","00407-004-2000636","00495-001-2000636","00506-001-2000658","00506-002-2000658","00513-001-2000638","00532-001-2000626","00532-002-2000626","00535-001-2000627","00535-002-2000626","00546-002-2000754","00546-002-2000763","00546-003-2000754","00551-001-2000744","00553-001-2000624","00555-001-2000591","00555-002-2000591","00584-001-2000503","00591-001-2000754","00591-001-2000763","00591-002-2000754","00591-002-2000763","00591-003-2000754","00591-003-2000763","00591-005-2000754","00606-001-2000617","00611-001-2000409","00622-001-2000632","00622-002-2000632","00645-001-2000296","00648-001-2000621","00682-001-2000642","00743-001-2000180","00758-001-2000639","00759-001-2000592","00773-001-2000602","00773-002-2000602","00773-003-2000602","00814-001-2000592","00814-005-2000593","00814-006-2000593","00814-007-2000593","00846-001-2000638","00876-001-2000601","00876-001-2000763","00938-001-2000607","00938-002-2000605","00940-001-2000605","00944-001-2000608","00944-002-2000608","00948-001-2000608","00948-002-2000608","00952-001-2000608","00952-002-2000608","00956-001-2000277","00956-002-2000277","00964-001-2000746","00969-001-2000583","00972-001-2000641","01051-001-2000286","01055-001-2000658","01058-001-2000286","01060-001-2000658","01069-001-2000658","01097-001-2000290","01102-001-2000636","01102-002-2000636","01121-001-2000634","01154-001-2000605","01157-001-2000605","01161-001-2000264","01187-001-2000609","01259-001-2000628","01270-001-2000505","01410-001-2000626","01414-001-2000601","01436-001-2000639","01442-001-2000639","01473-001-2000642","01652-001-2000592","01652-002-2000592","01681-001-2000626","01682-001-2000431","01696-001-2000602","01696-002-2000602","01696-003-2000602","01700-001-2000583","01718-001-2000635","01723-001-2000635","01743-001-2000607","01743-002-2000605","01760-002-2000596","01760-005-2000596","01760-006-2000596","01762-001-2000644","01762-002-2000647","01762-003-2000644","01824-001-2000636","01824-002-2000637","01863-001-2000655","01889-001-2000408","01962-001-2000617","02007-001-2000639","02007-002-2000639","02019-001-2000651","02028-001-2000654","02028-002-2000654","02047-001-2000641","02049-001-2000641","02049-002-2000646","02053-001-2000763","02053-001-2000844","02053-002-2000763","02053-002-2000844","02055-001-2000640","02059-001-2000181","02066-001-2000658","02073-001-2000658","02114-001-2000587","02145-001-2000609","02182-001-2000626","02218-001-2000401","02252-001-2000639","02487-001-2000592","02522-001-2000763","02525-001-2000592","02525-001-2000763","02525-002-2000592","02525-002-2000763","02525-005-2000593","02525-005-2000763","02525-006-2000593","02525-006-2000763","02525-007-2000593","02525-007-2000763","02525-008-2000593","02525-008-2000763","02525-009-2000756","02525-009-2000763","02525-010-2000756","02525-010-2000763","02525-011-2000594","02525-011-2000763","02525-012-2000594","02525-012-2000763","02525-013-2000594","02525-013-2000763","02743-001-2000420","02748-001-2000420","02755-001-2000592","02762-001-2000643","02807-001-2000602","02807-002-2000602","02807-003-2000602","02813-001-2000602","02813-002-2000602","02813-003-2000602","02816-001-2000658","02848-001-2000431","02849-001-2000417","02885-001-2000649","02892-001-2000637","02911-001-2000643","02945-001-2000632","02945-002-2000632","03096-001-2000506","03098-001-2000644","03098-002-2000645","03100-001-2000619","03149-001-2000599","03152-001-2000599","03153-001-2000599","03154-001-2000599","03154-002-2000599","03173-001-2000624","03186-001-2000417","03225-001-2000507","03225-002-2000507","03321-001-2000638","03350-001-2000588","03350-002-2000588","03353-001-2000601","03387-001-2000740","03428-001-2000600","03437-001-2000747","03443-001-2000606","03443-002-2000607","03445-002-2000605","03445-003-2000606","03445-004-2000607","03445-005-2000608","03447-001-2000605","03447-002-2000607","03471-001-2000643","03528-001-2000655","03554-001-2000606","03627-001-2000626","03653-001-2000411","03713-001-2000649","03718-001-2000634","03718-002-2000635","03718-003-2000635","03733-001-2000634","03733-002-2000639","03747-001-2000763","03751-001-2000756","03751-001-2000763","03751-002-2000592","03751-002-2000763","03751-003-2000593","03751-003-2000763","03751-004-2000593","03751-004-2000763","03751-005-2000593","03751-005-2000763","03751-006-2000594","03751-006-2000763","03751-007-2000594","03751-007-2000763","03751-008-2000757","03751-008-2000763","03751-009-2000757","03751-009-2000763","03751-010-2000757","03751-010-2000763","03751-011-2000758","03751-011-2000763","03751-012-2000758","03751-012-2000763","03763-001-2000602","03763-002-2000602","03763-003-2000602","03764-001-2000649","03774-001-2000650","03777-001-2000602","03777-002-2000602","03777-003-2000602","03801-001-2000746","03869-001-2000608","03869-002-2000606","03869-003-2000607","03869-004-2000609","03871-002-2000606","03871-003-2000607","03871-004-2000609","03961-001-2000601","03970-001-2000601","04025-001-2000608","04025-002-2000608","04025-003-2000608","04095-001-2000599","04109-001-2000445","04111-001-2000648","04115-001-2000644","04115-002-2000644","04126-001-2000648","04163-001-2000746","04163-001-2000763","04165-001-2000658","04167-001-2000740","04167-002-2000741","04216-001-2000613","04216-002-2000614","04216-003-2000614","04235-001-2000606","04240-001-2000639","04294-001-2000643","04303-001-2000639","04304-001-2000639","04310-001-2000655","04409-001-2000601","04422-001-2000601","04491-001-2000740","04518-001-2000618","04566-001-2000639","04566-002-2000639","04575-001-2000613","04600-001-2000606","04613-001-2000606","04651-001-2000650","04663-001-2000596","04663-003-2000647","04663-004-2000596","04663-005-2000647","04668-001-2000627","04739-001-2000658","04745-001-2000418","04755-001-2000408","04755-002-2000408","04757-001-2000632","04760-001-2000588","04760-002-2000588","04772-001-2000634","04772-002-2000635","04772-003-2000639","04772-004-2000639","04800-001-2000602","04800-002-2000602","04800-003-2000602","04813-001-2000264","04817-001-2000605","04817-002-2000607","04820-001-2000607","04836-001-2000634","04852-001-2000634","04864-001-2000600","04864-001-2000763","04864-002-2000600","04864-002-2000763","04865-001-2000600","04865-002-2000600","04896-001-2000759","04896-001-2000763","04910-001-2000638","04925-001-2000658","04960-001-2000638","04961-001-2000626","05080-001-2000635","05086-001-2000755","05086-001-2000763","05086-002-2000755","05086-002-2000763","05177-001-2000620","05229-001-2000620","05305-001-2000641","05310-001-2000658","05326-001-2000605","05372-001-2000634","05379-001-2000626","05379-002-2000626","05379-003-2000626","05379-004-2000626","05389-001-2000624","05432-001-2000608","05434-001-2000608","05436-001-2000608","05438-001-2000277","05441-001-2000609","05443-001-2000609","05445-001-2000609","05447-001-2000267","05449-001-2000606","05451-001-2000606","05453-001-2000606","05455-001-2000265","05467-001-2000607","05469-001-2000607","05471-001-2000607","05473-001-2000276","05484-001-2000605","05487-001-2000605","05489-001-2000605","05491-001-2000264","05514-001-2000180","05517-001-2000640","05562-001-2000640","05601-001-2000627","05634-001-2000592","05634-003-2000593","05634-004-2000593","05634-005-2000593","05660-001-2000420","05679-001-2000592","05679-002-2000592","05751-001-2000658","05773-001-2000401","05773-002-2000401","05778-001-2000644","05778-002-2000644","05790-001-2000623","05810-001-2000431","05916-001-2000640","05917-001-2000639","05946-001-2000601","05996-001-2000603","05996-002-2000603","05996-003-2000603","05996-004-2000603","06096-001-2000621","06115-001-2000742","06144-001-2000620","06169-001-2000627","06175-001-2000626","06190-001-2000599","06191-001-2000601","06200-001-2000264","06200-002-2000265","06200-003-2000276","06200-004-2000277","06211-001-2000600","06219-001-2000646","06219-002-2000420","06256-001-2000409","06289-001-2000634","06317-001-2000599","06317-001-2000763","06379-001-2000648","06382-001-2000648","06391-001-2000435","06395-001-2000602","06395-002-2000602","06395-003-2000602","06437-001-2000741","06474-001-2000648","06532-001-2000514","06533-001-2000641","06533-002-2000596","06533-003-2000646","06533-004-2000647","06533-006-2000596","06533-007-2000647","06547-001-2000759","06547-001-2000763","06557-001-2000638","06601-003-2000593","06601-003-2000763","06601-004-2000593","06601-004-2000763","06601-005-2000593","06601-005-2000763","06601-006-2000593","06601-006-2000763","06601-007-2000593","06601-007-2000763","06632-001-2000605","06644-001-2000649","06649-001-2000648","06661-001-2000648","06676-001-2000655","06710-001-2000635","06724-001-2000634","06724-002-2000634","06740-001-2000589","06740-001-2000763","06740-002-2000589","06740-002-2000763","06740-003-2000589","06740-003-2000763","06753-001-2000641","06754-001-2000646","06805-003-2000609","06805-004-2000609","06805-005-2000609","06845-001-2000609","06868-001-2000600","06913-001-2000635","06915-001-2000635","06925-001-2000255","06925-002-2000255","06938-001-2000651","07027-001-2000600","07029-001-2000276","07031-001-2000607","07034-001-2000607","07066-001-2000624","07068-001-2000658","07071-001-2000747","07073-001-2000739","07128-001-2000616","07128-002-2000616","07196-001-2000602","07196-002-2000602","07196-003-2000602","07206-001-2000745","07208-001-2000616","07228-001-2000600","07285-001-2000745","07296-001-2000748","07299-001-2000623","07314-001-2000745","07314-001-2000763","07427-001-2000744","07427-002-2000744","07429-001-2000622","07436-001-2000622","07456-001-2000629","07464-001-2000587","07530-001-2000605","07530-003-2000607","07530-004-2000608","07579-001-2000594","07579-001-2000763","07579-002-2000755","07579-002-2000763","07579-003-2000755","07579-003-2000763","07579-004-2000594","07579-004-2000763","07579-005-2000594","07579-005-2000763","07587-001-2000409","07590-001-2000595","07598-001-2000624","07614-001-2000658","07614-002-2000658","07635-001-2000635","07657-001-2000627","07661-001-2000754","07661-002-2000754","07661-003-2000754","07661-004-2000754","07661-005-2000754","07661-006-2000754","07661-006-2000763","07661-008-2000754","07661-008-2000763","07685-001-2000627","07686-001-2000506","07695-001-2000646","07699-001-2000592","07699-003-2000593","07699-004-2000593","07699-005-2000593","07723-001-2000658","07757-001-2000658","07779-001-2000658","07808-001-2000643","07809-001-2000590","07809-001-2000763","07809-002-2000590","07809-002-2000763","07809-003-2000590","07809-003-2000763","07818-001-2000740","07826-001-2000618","07827-001-2000618","07831-001-2000293","07906-001-2000503","07958-001-2000291","07962-001-2000617","07971-001-2000291","08001-001-2000742","08011-001-2000297","08021-001-2000614","08021-002-2000614","08105-001-2000639","08137-001-2000264","08141-001-2000295","08153-001-2000624","08153-002-2000625","08167-001-2000628","08193-001-2000601","08193-001-2000763","08212-001-2000409","08220-001-2000409","08223-001-2000409","08240-001-2000634","08265-001-2000636","08267-001-2000638","08272-001-2000417","08282-001-2000420","08285-001-2000590","08285-001-2000763","08285-002-2000590","08285-002-2000763","08286-001-2000637","08314-001-2000180","08336-001-2000639","08348-002-2000593","08348-003-2000593","08357-001-2000181","08371-001-2000647","08384-001-2000645","08389-001-2000645","08405-001-2000600","08406-001-2000600","08408-001-2000432","08412-001-2000601","08412-001-2000763","08430-001-2000648","08456-001-2000651","08459-001-2000651","08463-001-2000447","08468-001-2000651","08468-002-2000651","08481-001-2000653","08481-002-2000653","08484-001-2000603","08484-002-2000654","08484-003-2000655","08484-005-2000603","08484-006-2000603","08484-007-2000654","08489-001-2000653","08489-002-2000653","08490-001-2000653","08490-002-2000653","08491-001-2000653","08491-002-2000653","08504-001-2000653","08514-001-2000654","08515-001-2000654","08515-002-2000654","08517-001-2000654","08517-002-2000654","08525-001-2000654","08557-001-2000256","08571-002-2000609","08571-003-2000609","08573-001-2000264","08573-002-2000276","08579-001-2000606","08583-001-2000265","08586-001-2000608","08586-002-2000608","08588-001-2000608","08588-002-2000608","08590-001-2000608","08590-002-2000608","08593-001-2000277","08593-002-2000277","08602-001-2000609","08603-001-2000609","08657-003-2000641","08660-001-2000588","08661-002-2000642","08661-003-2000643","08663-002-2000642","08663-003-2000643","08663-004-2000643","08675-001-2000401","08683-001-2000644","08683-002-2000644","08705-001-2000639","08705-002-2000639","08707-001-2000639","08714-001-2000642","08723-001-2000635","08725-001-2000599","08736-001-2000599","08736-001-2000763","08741-001-2000620","08747-001-2000606","08749-001-2000606","08751-001-2000606","08756-001-2000618","08758-001-2000293","08775-001-2000658","08786-001-2000616","08811-001-2000614","08811-002-2000614","08815-001-2000614","08829-001-2000614","08832-001-2000614","08832-002-2000614","08835-001-2000628","08835-002-2000626","08866-001-2000514","08886-002-2000516","08886-003-2000516","08893-001-2000647","08894-001-2000645","08894-002-2000647","08894-004-2000647","08898-001-2000645","08904-001-2000589","08904-001-2000763","08904-002-2000589","08904-002-2000763","08904-003-2000589","08904-003-2000763","08933-001-2000636","08947-001-2000746","09025-001-2000634","09034-001-2000642","09035-001-2000642","09037-001-2000445","09042-001-2000180","09058-001-2000653","09058-002-2000653","09062-001-2000603","09062-002-2000654","09062-003-2000655","09062-004-2000603","09062-005-2000603","09067-001-2000654","09067-002-2000654","09068-001-2000654","09068-002-2000654","09069-001-2000653","09069-002-2000653","09071-001-2000255","09071-002-2000255","09083-001-2000654","09087-001-2000583","09116-001-2000645","09133-001-2000658","09139-001-2000601","09143-001-2000601","09145-001-2000433","09147-001-2000658","09151-001-2000286","09164-001-2000643","09164-002-2000643","09179-001-2000296","09184-001-2000405","09184-002-2000301","09188-001-2000405","09190-001-2000628","09190-002-2000628","09191-001-2000505","09216-001-2000411","09221-001-2000639","09221-002-2000639","09225-001-2000643","09225-002-2000643","09230-001-2000589","09230-001-2000763","09230-002-2000589","09230-002-2000763","09242-001-2000614","09247-001-2000614","09247-002-2000614","09247-003-2000614","09248-001-2000614","09248-002-2000614","09257-001-2000614","09257-002-2000614","09257-003-2000614","09258-001-2000614","09258-002-2000614","09267-001-2000614","09267-002-2000614","09268-001-2000614","09268-002-2000614","09269-001-2000441","09269-002-2000441","09271-001-2000441","09271-002-2000441","09277-001-2000613","09277-002-2000613","09291-001-2000613","09295-001-2000613","09317-001-2000630","09319-001-2000631","09323-001-2000630","09327-001-2000630","09333-001-2000587","09342-001-2000587","09357-001-2000614","09358-001-2000441","09375-001-2000599","09376-001-2000431","09401-001-2000651","09440-001-2000651","09440-002-2000651","09450-001-2000651","09464-001-2000651","09466-001-2000651","09466-002-2000651","09472-001-2000447","09472-002-2000447","09473-001-2000251","09473-002-2000447","09473-003-2000447","09476-001-2000251","09476-002-2000447","09476-003-2000447","09484-001-2000652","09485-001-2000652","09493-001-2000652","09497-001-2000651","09497-002-2000652","09497-003-2000651","09505-001-2000652","09514-001-2000251","09523-001-2000603","09523-003-2000603","09523-005-2000603","09524-001-2000651","09528-001-2000658","09538-001-2000598","09538-002-2000598","09543-001-2000598","09548-001-2000650","09548-002-2000598","09548-003-2000598","09549-001-2000598","09549-002-2000598","09552-001-2000598","09560-001-2000598","09560-002-2000598","09561-001-2000598","09561-002-2000598","09564-001-2000598","09564-002-2000598","09568-001-2000598","09568-002-2000598","09592-001-2000622","09594-001-2000622","09615-001-2000408","09635-001-2000647","09639-001-2000647","09642-001-2000517","09655-001-2000757","09655-001-2000763","09664-001-2000599","09666-001-2000431","09668-001-2000599","09668-001-2000763","09671-001-2000600","09671-001-2000763","09676-001-2000432","09678-001-2000650","09707-001-2000650","09712-001-2000650","09740-001-2000608","09740-002-2000608","09740-003-2000608","09742-001-2000608","09742-002-2000608","09742-003-2000608","09755-001-2000625","09756-001-2000624","09756-002-2000625","09762-001-2000625","09768-001-2000625","09778-001-2000658","09779-001-2000658","09787-001-2000651","09797-001-2000599","09797-001-2000763","09798-001-2000599","09800-001-2000599","09821-001-2000601","09835-001-2000760","09837-001-2000760","09852-002-2000747","09854-001-2000739","09854-002-2000739","09856-001-2000617","09860-001-2000296","09864-001-2000619","09886-001-2000742","09887-001-2000742","09889-001-2000621","09890-001-2000621","09893-001-2000296","09901-001-2000743","09903-001-2000743","09908-001-2000619","09910-001-2000619","09915-001-2000744","09919-001-2000622","09920-001-2000400","09922-001-2000745","09927-001-2000746","09929-001-2000583","09942-001-2000628","09942-002-2000628","09946-001-2000626","09946-002-2000626","09961-001-2000507","09962-001-2000627","09966-001-2000587","09967-001-2000587","09971-001-2000757","09971-001-2000763","09971-002-2000757","09971-002-2000763","09971-003-2000757","09971-003-2000763","09974-001-2000632","09974-002-2000632","09975-001-2000632","09984-001-2000632","09990-001-2000408","09991-001-2000408","09991-002-2000408","09996-001-2000589","09996-001-2000763","09996-002-2000589","09996-002-2000763","10000-001-2000655","10011-001-2000598","10011-002-2000598","10014-001-2000598","10014-002-2000598","10017-001-2000430","10020-001-2000598","10020-002-2000598","10021-001-2000430","10022-001-2000430","10023-001-2000658","10031-001-2000430","10031-002-2000430","10031-003-2000430","10031-004-2000430","10032-001-2000598","10032-002-2000598","10037-001-2000740","10042-001-2000754","10042-002-2000754","10042-003-2000754","10042-004-2000754","10042-005-2000754","10042-006-2000754","10042-006-2000763","10042-007-2000754","10073-001-2000650","10102-001-2000658","10105-001-2000658","10110-001-2000658","10110-002-2000658","10110-003-2000658","10110-004-2000658","10111-001-2000658","10111-002-2000658","10111-003-2000658","10116-001-2000658","10126-001-2000658","10150-001-2000658","10173-001-2000658","10219-001-2000598","10219-002-2000598","10220-001-2000598","10220-002-2000598","10220-003-2000598","10220-004-2000598","10220-005-2000598","10228-001-2000744","10235-001-2000623","10255-001-2000616","10259-001-2000618","10263-001-2000293","10265-001-2000619","10272-001-2000297","10273-001-2000297","10274-001-2000297","10275-001-2000741","10300-001-2000650","10301-001-2000650","10320-001-2000605","10320-002-2000606","10320-003-2000607","10320-004-2000608","10331-001-2000256","10331-002-2000264","10331-003-2000265","10331-004-2000267","10331-005-2000276","10331-006-2000277","10331-007-2000440","10331-008-2000441","10335-001-2000624","10336-001-2000624","10338-001-2000624","10341-001-2000626","10342-001-2000505","10347-001-2000648","10355-001-2000629","10363-001-2000630","10369-001-2000625","10371-001-2000625","10373-001-2000504","10379-001-2000634","10380-001-2000411","10381-001-2000414","10383-001-2000636","10386-001-2000636","10389-001-2000414","10392-001-2000637","10394-001-2000415","10396-001-2000636","10401-001-2000637","10404-001-2000639","10414-001-2000643","10419-001-2000640","10421-001-2000635","10422-001-2000635","10422-002-2000635","10433-001-2000651","10435-001-2000651","10436-001-2000651","10446-001-2000653","10446-002-2000653","10446-003-2000653","10448-001-2000653","10448-002-2000653","10449-001-2000653","10454-001-2000257","10456-001-2000257","10460-001-2000257","10468-001-2000596","10487-001-2000517","10487-002-2000517","10495-001-2000647","10516-001-2000605","10516-002-2000606","10516-003-2000607","10516-004-2000608","10520-001-2000265","10522-001-2000608","10526-001-2000609","10531-001-2000430","10532-001-2000430","10533-001-2000430","10546-001-2000590","10546-001-2000763","10546-002-2000590","10546-002-2000763","10549-001-2000637","10556-001-2000637","10557-001-2000637","10560-001-2000637","10563-001-2000639","10576-002-2000617","10576-004-2000621","10576-006-2000586","10576-008-2000624","10576-011-2000635","10576-013-2000639","10576-014-2000640","10576-017-2000600","10576-018-2000654","10576-019-2000613","10576-021-2000586","10576-023-2000511","10576-024-2000511","10576-025-2000511","10576-026-2000639","10576-027-2000626","10577-004-2000408","10577-006-2000414","10577-009-2000420","10577-010-2000445","10577-011-2000446","10577-012-2000511","10577-013-2000517","10577-014-2000430","10577-015-2000431","10577-017-2000435","10577-018-2000436","10577-019-2000437","10577-020-2000251","10577-021-2000256","10577-022-2000257","10577-024-2000605","10577-025-2000606","10577-027-2000608","10577-029-2000614","10577-031-2000447","10578-002-2000593","10578-005-2000593","10578-006-2000593","10578-007-2000593","10581-002-2000640","10581-003-2000641","10581-004-2000640","10581-005-2000641","10582-001-2000641","10585-001-2000181","10586-001-2000181","10588-001-2000181","10590-002-2000594","10590-002-2000763","10590-003-2000594","10590-003-2000763","10594-001-2000643","10597-001-2000446","10598-001-2000446","10603-001-2000642","10606-001-2000763","10606-001-2000844","10606-002-2000763","10606-002-2000844","10606-003-2000763","10606-003-2000844","10607-001-2000595","10607-002-2000595","10614-001-2000644","10615-001-2000644","10615-002-2000644","10624-001-2000515","10629-001-2000646","10632-001-2000646","10636-001-2000516","10643-001-2000647","10644-001-2000647","10645-001-2000647","10645-002-2000647","10647-001-2000517","10652-001-2000430","10659-001-2000602","10659-002-2000602","10659-003-2000602","10664-001-2000648","10665-001-2000648","10667-001-2000648","10669-001-2000648","10674-001-2000435","10675-001-2000435","10681-001-2000649","10682-001-2000649","10683-001-2000649","10684-001-2000649","10691-001-2000649","10693-001-2000649","10694-001-2000649","10695-001-2000649","10696-001-2000649","10697-001-2000649","10703-001-2000436","10704-001-2000436","10705-001-2000436","10712-001-2000650","10713-001-2000650","10714-001-2000650","10720-001-2000437","10721-001-2000437","10726-001-2000652","10728-001-2000257","10728-002-2000257","10736-001-2000654","10737-001-2000654","10738-001-2000655","10749-001-2000605","10753-001-2000606","10755-001-2000265","10759-001-2000265","10774-001-2000267","10775-001-2000267","10784-001-2000613","10786-001-2000613","10786-002-2000441","10786-003-2000440","10790-001-2000614","10791-001-2000441","10816-001-2000615","10819-001-2000615","10821-001-2000518","10825-001-2000518","10831-001-2000615","10843-001-2000615","10844-001-2000615","10846-001-2000615","10854-001-2000658","10854-002-2000658","10854-003-2000658","10854-004-2000658","10854-005-2000658","10854-006-2000658","10854-007-2000658","10854-008-2000658","10854-009-2000658","10854-010-2000658","10858-001-2000602","10858-002-2000602","10858-003-2000602","10860-001-2000588","10860-001-2000589","10860-001-2000590","10860-001-2000591","10860-001-2000592","10860-001-2000593","10860-001-2000594","10860-002-2000588","10860-002-2000589","10860-002-2000590","10860-002-2000591","10860-002-2000592","10860-002-2000593","10860-002-2000594","10860-003-2000588","10860-003-2000589","10860-003-2000590","10860-003-2000591","10860-003-2000592","10860-003-2000593","10860-003-2000594","10860-004-2000588","10860-004-2000589","10860-004-2000590","10860-004-2000591","10860-004-2000592","10860-004-2000593","10860-004-2000594","10860-005-2000588","10860-005-2000589","10860-005-2000590","10860-005-2000591","10860-005-2000592","10860-005-2000593","10860-005-2000594","10860-006-2000588","10860-006-2000589","10860-006-2000590","10860-006-2000591","10860-006-2000592","10860-006-2000593","10860-006-2000594","10860-007-2000588","10860-007-2000589","10860-007-2000590","10860-007-2000591","10860-007-2000592","10860-007-2000593","10860-007-2000594","10860-008-2000588","10860-008-2000589","10860-008-2000590","10860-008-2000591","10860-008-2000592","10860-008-2000593","10860-008-2000594","10860-009-2000588","10860-009-2000589","10860-009-2000590","10860-009-2000591","10860-009-2000592","10860-009-2000593","10860-009-2000594","10860-010-2000588","10860-010-2000589","10860-010-2000590","10860-010-2000591","10860-010-2000592","10860-010-2000593","10860-010-2000594","10860-011-2000588","10860-011-2000589","10860-011-2000590","10860-011-2000591","10860-011-2000592","10860-011-2000593","10860-011-2000594","10860-012-2000588","10860-012-2000589","10860-012-2000590","10860-012-2000591","10860-012-2000592","10860-012-2000593","10860-012-2000594","10860-013-2000588","10860-013-2000589","10860-013-2000590","10860-013-2000591","10860-013-2000592","10860-013-2000593","10860-013-2000594","10860-014-2000588","10860-014-2000589","10860-014-2000590","10860-014-2000591","10860-014-2000592","10860-014-2000593","10860-014-2000594","10860-015-2000588","10860-015-2000589","10860-015-2000590","10860-015-2000591","10860-015-2000592","10860-015-2000593","10860-015-2000594","10860-016-2000588","10860-016-2000589","10860-016-2000590","10860-016-2000591","10860-016-2000592","10860-016-2000593","10860-016-2000594","10860-017-2000588","10860-017-2000589","10860-017-2000590","10860-017-2000591","10860-017-2000592","10860-017-2000593","10860-017-2000594","10860-018-2000595","10860-018-2000596","10860-018-2000597","10860-019-2000595","10860-019-2000596","10860-019-2000597","10860-020-2000595","10860-020-2000596","10860-020-2000597","10860-021-2000595","10860-021-2000596","10860-021-2000597","10860-022-2000595","10860-022-2000596","10860-022-2000597","10860-023-2000595","10860-023-2000596","10860-023-2000597","10860-024-2000595","10860-024-2000596","10860-024-2000597","10860-025-2000598","10860-026-2000598","10860-027-2000599","10860-027-2000600","10860-027-2000601","10860-028-2000599","10860-028-2000600","10860-028-2000601","10860-029-2000599","10860-029-2000600","10860-029-2000601","10871-001-2000658","10871-002-2000658","10872-001-2000658","10873-001-2000658","10875-001-2000658","10878-001-2000658","10882-001-2000658","10887-001-2000658","10888-001-2000658","10890-001-2000658","10911-001-2000658","10932-001-2000286","10939-001-2000658","10940-001-2000605","10940-002-2000606","10940-003-2000608","10940-004-2000759","10942-001-2000658","10944-001-2000653","10944-002-2000654","10944-003-2000655","10944-004-2000653","10944-005-2000654","10945-001-2000255","10950-001-2000654","10950-002-2000654","10952-001-2000628","10953-001-2000595","10953-002-2000595","10958-001-2000507","10960-001-2000507","10961-001-2000628","10965-001-2000632","10968-002-2000595","10968-003-2000595","10971-001-2000595","10971-002-2000595","10975-001-2000743","10976-001-2000295","10978-001-2000595","10978-002-2000595","10979-001-2000628","10989-001-2000595","10989-002-2000595","10990-001-2000595","10993-001-2000601","10994-001-2000601","10996-001-2000507","11002-001-2000632","11003-001-2000628","11005-001-2000623","11006-001-2000405","11010-001-2000654","11014-001-2000643","11017-001-2000658","11018-001-2000658","11023-001-2000658","11024-001-2000658","11029-001-2000658","11029-002-2000658","11029-003-2000658","11029-004-2000658","11029-005-2000658","11029-006-2000658","11029-007-2000658","11030-002-2000658","11030-003-2000658","11030-004-2000658","11030-005-2000658","11030-006-2000658","11030-007-2000658","11031-001-2000658","11031-002-2000658","11031-003-2000658","11031-004-2000658","11031-005-2000658","11031-007-2000658","11031-008-2000658","11031-009-2000658","11032-001-2000658","11032-002-2000658","11032-003-2000658","11032-004-2000658","11033-001-2000658","11033-002-2000658","11033-003-2000658","11033-005-2000658","11034-001-2000658","11034-002-2000658","11034-004-2000658","11034-005-2000658","11034-006-2000658","11034-007-2000658","11034-008-2000658","11034-009-2000658","11035-001-2000658","11038-001-2000658","11046-001-2000658","11046-002-2000658","11051-001-2000658","11052-001-2000658","11062-001-2000658","11062-002-2000658","11062-003-2000658","11065-001-2000658","11066-001-2000658","11067-002-2000739","11067-002-2000763","11068-001-2000658","11069-001-2000658","11071-001-2000658","11072-001-2000658","11072-002-2000658","11076-001-2000658","11079-001-2000658","11080-001-2000658","11081-001-2000658","11082-001-2000658","11084-001-2000658","11087-001-2000658","11090-001-2000658","11095-001-2000658","11099-001-2000658","11103-001-2000658","11104-001-2000658","11107-001-2000658","11112-001-2000658","11112-002-2000658","11112-003-2000658","11114-001-2000658","11115-001-2000658","11115-002-2000658","11115-003-2000658","11115-004-2000658","11115-005-2000658","11116-001-2000658","11116-002-2000658","11127-001-2000658","11128-001-2000658","11132-001-2000658","11132-002-2000658","11135-001-2000658","11141-001-2000642","11141-001-2000763","11143-001-2000745","11144-001-2000642","11146-001-2000445","11159-001-2000658","11160-001-2000658","11160-002-2000658","11161-001-2000658","11161-002-2000658","11163-001-2000658","11171-001-2000658","11171-002-2000658","11173-001-2000286","11173-002-2000286","11180-001-2000658","11208-001-2000658","11208-002-2000658","11209-001-2000658","11210-001-2000658","11211-001-2000658","11212-001-2000658","11213-001-2000658","11214-001-2000658","11214-002-2000658","11216-001-2000658","11218-001-2000658","11221-001-2000658","11223-001-2000653","11223-002-2000653","11225-001-2000517","11228-001-2000658","11232-001-2000652","11237-001-2000615","11240-001-2000606","11241-001-2000636","11243-001-2000414","11246-001-2000609","11248-001-2000585","11255-001-2000631","11256-001-2000631","11259-001-2000615","11264-001-2000503","11267-001-2000608","11275-001-2000658","11277-001-2000440","11281-001-2000590","11281-001-2000763","11281-002-2000590","11281-002-2000763","11284-001-2000613","11288-001-2000595","11289-001-2000658","11292-002-2000418","11301-001-2000614","11302-001-2000614","11302-002-2000614","11304-001-2000658","11308-001-2000264","11308-002-2000265","11308-003-2000267","11308-004-2000276","11308-005-2000277","11310-001-2000655","11312-001-2000658","11315-001-2000658","11321-001-2000613","11324-001-2000658","11324-002-2000658","11325-001-2000658","11326-001-2000658","11328-001-2000606","11333-001-2000601","11338-001-2000631","11339-001-2000658","11340-001-2000614","11356-001-2000605","11357-001-2000608","11358-001-2000609","11359-001-2000606","11360-001-2000607","11366-001-2000605","11367-001-2000608","11368-001-2000609","11369-001-2000606","11370-001-2000607","11371-001-2000277","11372-001-2000267","11373-001-2000265","11374-001-2000264","11375-001-2000276","11376-001-2000615","11377-001-2000658","11380-001-2000605","11382-001-2000613","11385-001-2000613","11386-001-2000613","11386-002-2000613","11388-001-2000613","11388-002-2000613","11390-001-2000440","11390-002-2000440","11395-001-2000256","11397-001-2000614","11398-001-2000647","11398-002-2000647","11401-001-2000655","11402-001-2000515","11403-001-2000658","11405-001-2000276","11405-002-2000277","11406-001-2000595","11412-001-2000609","11414-001-2000609","11415-001-2000754","11415-002-2000757","11415-003-2000759","11415-004-2000844","11415-005-2000603","11415-006-2000653","11415-007-2000654","11415-008-2000655","11415-009-2000605","11415-010-2000606","11415-011-2000607","11415-012-2000608","11415-013-2000609","11415-014-2000613","11415-015-2000614","11415-016-2000615","11415-017-2000763","11415-018-2000754","11415-019-2000754","11415-020-2000754","11415-021-2000754","11415-022-2000757","11415-023-2000757","11415-024-2000844","11415-026-2000603","11415-027-2000763","11415-028-2000763","11415-029-2000763","11415-030-2000763","11415-031-2000763","11415-032-2000763","11415-033-2000763","11415-034-2000763","11415-035-2000763","11415-036-2000763","11415-037-2000763","11415-038-2000763","11415-039-2000763","11415-040-2000763","11415-041-2000763","11415-042-2000763","11416-001-2000585","11416-002-2000586","11416-003-2000587","11416-004-2000595","11416-005-2000596","11416-006-2000597","11416-007-2000603","11416-008-2000604","11416-009-2000605","11416-010-2000606","11416-011-2000607","11416-012-2000608","11416-013-2000609","11416-014-2000613","11416-015-2000614","11416-016-2000615","11416-017-2000587","11416-018-2000587","11416-019-2000586","11416-020-2000586","11416-021-2000595","11416-022-2000595","11416-023-2000596","11416-024-2000596","11416-026-2000603","11416-027-2000604","11416-028-2000604","11416-029-2000597","11417-001-2000581","11417-002-2000581","11417-003-2000582","11417-004-2000583","11417-005-2000584","11417-006-2000585","11417-007-2000586","11417-008-2000587","11417-009-2000595","11417-010-2000596","11417-011-2000597","11417-012-2000603","11417-013-2000604","11417-014-2000605","11417-015-2000606","11417-016-2000607","11417-017-2000608","11417-018-2000609","11417-019-2000613","11417-020-2000614","11417-021-2000615","11417-022-2000581","11417-023-2000580","11417-024-2000587","11417-025-2000587","11417-026-2000586","11417-027-2000586","11417-028-2000595","11417-029-2000595","11417-030-2000596","11417-031-2000596","11417-033-2000603","11417-034-2000604","11417-035-2000604","11417-036-2000582","11417-037-2000580","11417-038-2000581","11417-039-2000582","11417-040-2000597","11418-001-2000505","11419-001-2000592","11419-002-2000592","11420-001-2000624","11422-001-2000652","11423-001-2000440","11423-002-2000441","11425-001-2000256","11432-001-2000587","11438-001-2000658","11438-002-2000658","11447-001-2000613","11447-002-2000613","11449-001-2000606","11450-001-2000613","11450-002-2000613","11452-001-2000613","11454-001-2000607","11458-001-2000651","11458-002-2000652","11459-001-2000658","11460-001-2000658","11463-001-2000649","11467-001-2000658","11470-001-2000652","11471-001-2000658","11480-001-2000717","11483-001-2000717","11484-001-2000717","11485-001-2000717","11487-001-2000717","11488-001-2000717","11499-001-2000658","11509-001-2000715","11511-001-2000715","11512-001-2000715","11513-001-2000715","11517-001-2000553","11518-001-2000553","11519-001-2000553","11520-001-2000506","11521-001-2000627","11525-001-2000600","11526-001-2000600","11528-003-2000650","11532-001-2000595","11532-002-2000595","11535-001-2000625","11538-001-2000609","11538-002-2000609","11540-001-2000609","11540-002-2000609","11542-001-2000609","11542-002-2000609","11544-001-2000267","11544-002-2000267","11548-001-2000747","11548-001-2000763","11554-001-2000642","11558-001-2000716","11558-002-2000716","11562-001-2000559","11566-001-2000716","11567-001-2000559","11568-001-2000716","11571-001-2000658","11573-001-2000658","11576-001-2000658","11585-001-2000587","11587-001-2000716","11599-001-2000180","11606-001-2000615","11611-001-2000658","11614-001-2000658","11616-001-2000658","11617-001-2000658","11619-001-2000658","11619-002-2000658","11621-001-2000658","11627-001-2000600","11633-001-2000598","11633-002-2000598","11638-001-2000615","11639-001-2000658","11647-001-2000592","11652-001-2000632","11659-001-2000739","11660-001-2000739","11666-002-2000739","11670-001-2000739","11683-001-2000748","11686-001-2000551","11687-001-2000551","11690-001-2000584","11691-001-2000551","11694-001-2000748","11694-001-2000763","11700-001-2000584","11701-001-2000748","11703-001-2000598","11703-002-2000598","11705-001-2000598","11708-001-2000653","11708-002-2000655","11713-001-2000430","11714-001-2000655","11715-001-2000655","11717-001-2000655","11718-001-2000653","11719-001-2000655","11721-001-2000598","11721-002-2000598","11724-001-2000653","11724-002-2000655","11724-003-2000653","11729-001-2000257","11730-001-2000256","11731-001-2000655","11731-002-2000655","11733-001-2000653","11733-002-2000653","11738-001-2000741","11743-001-2000741","11744-001-2000741","11750-001-2000741","11750-001-2000763","11751-001-2000741","11753-001-2000742","11753-001-2000763","11755-001-2000742","11759-001-2000743","11761-001-2000743","11761-001-2000763","11763-001-2000740","11763-001-2000763","11764-001-2000744","11764-001-2000763","11764-002-2000744","11769-001-2000748","11775-001-2000747","11776-001-2000747","11785-001-2000760","11787-001-2000748","11789-001-2000763","11789-002-2000763","11789-003-2000763","11789-004-2000763","11789-005-2000763","11789-006-2000763","11789-007-2000763","11789-008-2000738","11789-009-2000738","11789-010-2000738","11789-011-2000738","11789-012-2000738","11789-013-2000738","11789-014-2000738","11789-015-2000738","11789-016-2000738","11789-017-2000738","11789-018-2000738","11789-019-2000754","11789-020-2000754","11789-021-2000754","11789-022-2000754","11789-023-2000754","11789-024-2000754","11789-025-2000754","11789-026-2000754","11789-027-2000754","11789-029-2000755","11789-030-2000755","11789-031-2000589","11789-032-2000589","11789-033-2000589","11789-034-2000589","11789-035-2000590","11789-036-2000590","11789-037-2000590","11789-038-2000756","11789-039-2000756","11789-040-2000756","11789-041-2000592","11789-042-2000592","11789-043-2000593","11789-044-2000593","11789-045-2000593","11789-046-2000593","11789-047-2000593","11789-048-2000593","11789-049-2000594","11789-050-2000594","11789-051-2000594","11789-052-2000594","11789-053-2000757","11789-054-2000757","11789-055-2000757","11789-056-2000757","11789-057-2000758","11789-058-2000758","11789-059-2000758","11789-060-2000758","11789-061-2000759","11789-062-2000759","11789-063-2000598","11789-064-2000598","11789-065-2000598","11789-066-2000598","11789-067-2000598","11789-068-2000599","11789-069-2000599","11789-070-2000600","11789-071-2000600","11789-072-2000601","11789-073-2000601","11789-074-2000602","11789-075-2000602","11789-076-2000602","11789-077-2000602","11789-078-2000603","11789-079-2000603","11789-080-2000603","11789-081-2000603","11789-082-2000653","11789-083-2000653","11789-084-2000654","11789-085-2000655","11789-086-2000605","11789-087-2000606","11789-088-2000607","11789-089-2000607","11789-090-2000608","11789-091-2000608","11789-092-2000609","11789-093-2000613","11789-094-2000614","11789-095-2000615","11789-096-2000658","11789-097-2000658","11789-098-2000658","11789-099-2000658","11789-100-2000658","11789-101-2000658","11790-001-2000757","11790-002-2000757","11790-003-2000757","11790-004-2000757","11790-005-2000758","11790-006-2000758","11790-007-2000758","11790-008-2000758","11790-009-2000759","11790-010-2000759","11791-001-2000763","11791-002-2000763","11791-003-2000763","11791-004-2000763","11791-005-2000763","11791-006-2000763","11791-007-2000763","11791-008-2000738","11791-009-2000738","11791-010-2000738","11791-011-2000738","11791-012-2000738","11791-013-2000738","11791-014-2000738","11791-015-2000738","11791-016-2000738","11791-017-2000738","11791-018-2000738","11791-019-2000754","11791-020-2000754","11791-021-2000754","11791-022-2000754","11791-023-2000754","11791-024-2000754","11791-025-2000754","11791-026-2000754","11791-027-2000754","11791-029-2000598","11791-030-2000598","11791-031-2000598","11791-032-2000598","11791-033-2000598","11791-034-2000599","11791-035-2000599","11791-036-2000600","11791-037-2000600","11791-038-2000601","11791-039-2000601","11791-040-2000602","11791-041-2000602","11791-042-2000602","11791-043-2000602","11791-044-2000603","11791-045-2000603","11791-046-2000603","11791-047-2000603","11791-048-2000653","11791-049-2000653","11791-050-2000654","11791-051-2000655","11791-052-2000605","11791-053-2000606","11791-054-2000607","11791-055-2000607","11791-056-2000608","11791-057-2000608","11791-058-2000609","11791-059-2000613","11791-060-2000614","11791-061-2000615","11791-062-2000658","11791-063-2000658","11792-001-2000763","11792-002-2000763","11792-003-2000763","11792-004-2000763","11792-005-2000738","11792-005-2000763","11792-006-2000738","11792-007-2000738","11792-008-2000738","11792-009-2000738","11792-010-2000738","11792-011-2000738","11792-012-2000738","11792-013-2000757","11792-013-2000759","11792-014-2000757","11792-014-2000759","11792-015-2000757","11792-015-2000759","11792-016-2000757","11792-016-2000759","11792-017-2000598","11792-018-2000598","11792-019-2000598","11792-020-2000599","11792-020-2000600","11792-020-2000601","11792-020-2000602","11792-021-2000599","11792-021-2000600","11792-021-2000601","11792-021-2000602","11792-022-2000599","11792-022-2000600","11792-022-2000601","11792-022-2000602","11792-023-2000599","11792-023-2000600","11792-023-2000601","11792-023-2000602","11792-024-2000599","11792-024-2000600","11792-024-2000601","11792-024-2000602","11792-025-2000599","11792-025-2000600","11792-025-2000601","11792-025-2000602","11792-026-2000603","11792-026-2000604","11792-027-2000603","11792-027-2000604","11792-028-2000603","11792-028-2000604","11792-029-2000603","11792-029-2000604","11792-030-2000603","11792-030-2000604","11792-031-2000603","11792-031-2000604","11793-001-2000754","11793-002-2000754","11793-003-2000754","11793-004-2000754","11793-005-2000754","11793-006-2000754","11793-007-2000754","11793-008-2000754","11793-009-2000754","11793-010-2000758","11793-011-2000758","11793-012-2000758","11793-013-2000758","11793-014-2000755","11793-015-2000589","11793-016-2000590","11793-017-2000756","11793-018-2000592","11793-019-2000593","11793-020-2000593","11793-021-2000594","11793-022-2000605","11793-023-2000606","11793-024-2000607","11793-025-2000608","11793-026-2000609","11793-027-2000610","11794-001-2000658","11794-003-2000658","11794-004-2000658","11794-005-2000658","11794-006-2000658","11794-007-2000658","11794-008-2000658","11794-009-2000658","11794-010-2000658","11794-011-2000658","11794-012-2000658","11794-013-2000658","11794-014-2000658","11794-015-2000658","11794-016-2000658","11794-017-2000658","11794-018-2000658","11794-019-2000658","11794-020-2000658","11794-021-2000658","11794-022-2000658","11794-023-2000658","11794-024-2000658","11799-001-2000601","11800-001-2000601","11800-002-2000595","12436-001-2000754","12436-002-2000754","12436-003-2000754","12436-004-2000754","12436-005-2000754","12436-006-2000754","12436-006-2000763","12436-007-2000754","12502-001-2000615","12503-001-2000615","12521-001-2000608","12530-001-2000608","12538-001-2000605","12538-002-2000609","12539-001-2000609","12565-001-2000606","12566-001-2000606","12585-001-2000605","12587-001-2000605","12615-001-2000584","12620-001-2000584","12621-001-2000551","12641-001-2000757","12641-002-2000757","12641-003-2000757","12644-001-2000595","12644-002-2000595","12648-001-2000595","12666-001-2000759","12666-001-2000763","12667-001-2000759","12667-001-2000763","12681-001-2000763","12681-001-2000844","12681-002-2000763","12681-002-2000844","12715-001-2000658","12717-001-2000658","12718-001-2000658","12720-001-2000658","12721-001-2000658","12722-001-2000658","12723-001-2000658","12725-001-2000658","12726-001-2000658","12727-001-2000658","12729-001-2000658","12730-001-2000658","12731-001-2000658","12732-001-2000658","12733-001-2000658","12733-002-2000658","12749-001-2000654","12749-002-2000654","12750-001-2000654","12768-001-2000613","12768-002-2000613","12785-001-2000609","12800-001-2000755","12800-001-2000763"])

export const LEGACY_1_3_CHANGED_COURSES_BY_ID = {
  "00295-001-2000599": {
    "name": "가족복지론",
    "professor": "차승은",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 8,
    "room": "생활305",
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8
        ],
        "classroom": "생활305"
      },
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "생활305"
      }
    ]
  },
  "00551-001-2000744": {
    "name": "경제법",
    "professor": "정우식",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문310",
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문310"
      }
    ]
  },
  "00773-003-2000602": {
    "name": "골프1(운동건강관리전공)",
    "professor": "박병철",
    "credits": 1,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "미래B203",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "미래B203"
      }
    ]
  },
  "02007-001-2000639": {
    "name": "동역학",
    "professor": "송준솔",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "자연관309",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "자연관309"
      }
    ]
  },
  "02007-002-2000639": {
    "name": "동역학",
    "professor": "송준솔",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "자연관309",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "자연관309"
      }
    ]
  },
  "02019-001-2000651": {
    "name": "드로잉4",
    "professor": "최혜란",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "",
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": ""
      }
    ]
  },
  "02743-001-2000420": {
    "name": "박막공학",
    "professor": "이상혁",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "자연대B105",
    "meetings": [
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "자연대B105"
      },
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "종합503"
      }
    ]
  },
  "02748-001-2000420": {
    "name": "반도체공정",
    "professor": "이상혁",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "자연대B105",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "자연대B105"
      },
      {
        "day": "월",
        "periods": [
          3
        ],
        "classroom": "종합412"
      }
    ]
  },
  "02848-001-2000431": {
    "name": "보육실습",
    "professor": "김윤희",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금",
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "생활202",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "생활202"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "생활502"
      }
    ]
  },
  "03100-001-2000619": {
    "name": "비즈니스러시아어",
    "professor": "마리나세르게예브나",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합504",
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합504"
      },
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "종합505"
      }
    ]
  },
  "03225-002-2000507": {
    "name": "상사중재론(이러닝_재직자반)",
    "professor": "이수현",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목",
      "토"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "글경604",
    "meetings": [
      {
        "day": "목",
        "periods": [
          9
        ],
        "classroom": "글경604"
      },
      {
        "day": "토",
        "periods": [
          1,
          2
        ],
        "classroom": "글경604"
      }
    ]
  },
  "03387-001-2000740": {
    "name": "생활영어회화2",
    "professor": "니콜라스",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문301",
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문301"
      }
    ]
  },
  "03733-002-2000639": {
    "name": "수치해석",
    "professor": "송준솔",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "자연대211",
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "자연대211"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "자연관309"
      }
    ]
  },
  "03777-001-2000602": {
    "name": "스포츠사회학(체육전공)",
    "professor": "박승일",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B202",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B202"
      }
    ]
  },
  "03777-002-2000602": {
    "name": "스포츠사회학(레저스포츠전공)",
    "professor": "박승일",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래B202",
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래B202"
      }
    ]
  },
  "03777-003-2000602": {
    "name": "스포츠사회학(운동건강관리전공)",
    "professor": "박승일",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래B202",
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래B202"
      }
    ]
  },
  "04095-001-2000599": {
    "name": "아동상담",
    "professor": "김수지",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "IT106",
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "IT106"
      }
    ]
  },
  "04111-001-2000648": {
    "name": "안전교육",
    "professor": "이지선",
    "credits": 2,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육116",
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "체육116"
      }
    ]
  },
  "04566-001-2000639": {
    "name": "컴퓨터프로그래밍",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대211",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대211"
      }
    ]
  },
  "04566-002-2000639": {
    "name": "컴퓨터프로그래밍",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대211",
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대211"
      }
    ]
  },
  "04772-002-2000635": {
    "name": "유체역학",
    "professor": "성기명",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합410",
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "종합410"
      },
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "종합410"
      }
    ]
  },
  "04800-001-2000602": {
    "name": "육상1(학부A반)",
    "professor": "윤신혜",
    "credits": 1,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "체육112",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "체육112"
      }
    ]
  },
  "04800-002-2000602": {
    "name": "육상1(학부B반)",
    "professor": "윤신혜",
    "credits": 1,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "체육112",
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "체육112"
      }
    ]
  },
  "04800-003-2000602": {
    "name": "육상1(학부C반)",
    "professor": "윤신혜",
    "credits": 1,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육112",
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "체육112"
      }
    ]
  },
  "04896-001-2000759": {
    "name": "이산수학",
    "professor": "이지훈",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT307",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT307"
      }
    ]
  },
  "04896-001-2000763": {
    "name": "이산수학",
    "professor": "이지훈",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT307",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT307"
      }
    ]
  },
  "04925-001-2000658": {
    "name": "인간과우주",
    "professor": "김충섭",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래110",
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래110"
      }
    ]
  },
  "05229-001-2000620": {
    "name": "일어음성학",
    "professor": "김선희",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "인문313",
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "인문313"
      },
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "인문313"
      }
    ]
  },
  "05310-001-2000658": {
    "name": "자연과학의이해",
    "professor": "김상준",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래109",
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래109"
      }
    ]
  },
  "05432-001-2000608": {
    "name": "전공실기2(관현악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05434-001-2000608": {
    "name": "전공실기4(관현악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05436-001-2000608": {
    "name": "전공실기6(관현악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05438-001-2000277": {
    "name": "전공실기8(관현악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05441-001-2000609": {
    "name": "전공실기2(국악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05443-001-2000609": {
    "name": "전공실기4(국악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05445-001-2000609": {
    "name": "전공실기6(국악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05447-001-2000267": {
    "name": "전공실기8(국악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05449-001-2000606": {
    "name": "전공실기2(성악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05451-001-2000606": {
    "name": "전공실기4(성악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05453-001-2000606": {
    "name": "전공실기6(성악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05455-001-2000265": {
    "name": "전공실기8(성악)",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05484-001-2000605": {
    "name": "전공실기2",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05487-001-2000605": {
    "name": "전공실기4",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05489-001-2000605": {
    "name": "전공실기6",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05491-001-2000264": {
    "name": "전공실기8",
    "professor": "",
    "credits": 2,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "05601-001-2000627": {
    "name": "전산회계",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경401",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경401"
      }
    ]
  },
  "05917-001-2000639": {
    "name": "제조공학",
    "professor": "진장민",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "종합405",
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "종합405"
      },
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "종합503"
      }
    ]
  },
  "06753-001-2000641": {
    "name": "통신시스템설계",
    "professor": "이창수",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "자연관406",
    "meetings": [
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "자연관406"
      },
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "종합302"
      }
    ]
  },
  "06913-001-2000635": {
    "name": "폐기물처리공학",
    "professor": "백승기",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "종합302",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4
        ],
        "classroom": "종합302"
      },
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합302"
      }
    ]
  },
  "07208-001-2000616": {
    "name": "한국현대미디어문학론",
    "professor": "김중신",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문509",
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문509"
      }
    ]
  },
  "07296-001-2000748": {
    "name": "행정법총론2",
    "professor": "권설아",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문506",
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문506"
      }
    ]
  },
  "07427-001-2000744": {
    "name": "형법총론2",
    "professor": "권지혜",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문409",
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문409"
      }
    ]
  },
  "07436-001-2000622": {
    "name": "행정법1",
    "professor": "윤서영",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "인문310",
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "인문310"
      }
    ]
  },
  "07579-003-2000755": {
    "name": "화학및실험2",
    "professor": "강성수",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대505",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대505"
      }
    ]
  },
  "07579-003-2000763": {
    "name": "화학및실험2",
    "professor": "강성수",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연대505",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연대505"
      }
    ]
  },
  "07590-001-2000595": {
    "name": "확률론",
    "professor": "정형철",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "글경314",
    "meetings": [
      {
        "day": "월",
        "periods": [
          3
        ],
        "classroom": "글경314"
      },
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "글경315"
      }
    ]
  },
  "07614-001-2000658": {
    "name": "환경과학",
    "professor": "김미아",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합507",
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합507"
      }
    ]
  },
  "07614-002-2000658": {
    "name": "환경과학",
    "professor": "김미아",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합507",
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합507"
      }
    ]
  },
  "07661-001-2000754": {
    "name": "회계원리(1-1전용반_마이크로디그리)",
    "professor": "윤명옥",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경601",
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경601"
      }
    ]
  },
  "07661-003-2000754": {
    "name": "회계원리(1-3전용반_마이���로디그리)",
    "professor": "신하준",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경B102",
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경B102"
      }
    ]
  },
  "07661-004-2000754": {
    "name": "회계원리(1-4전용반_마이크로디그리)",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경B103",
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경B103"
      }
    ]
  },
  "07661-005-2000754": {
    "name": "회계원리(1-5전용반_마이크로디그리)",
    "professor": "김동선",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "글경601",
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "글경601"
      }
    ]
  },
  "07661-006-2000754": {
    "name": "회계원리",
    "professor": "우동호",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경402",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경402"
      }
    ]
  },
  "07661-006-2000763": {
    "name": "회계원리",
    "professor": "우동호",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경402",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경402"
      }
    ]
  },
  "07661-008-2000754": {
    "name": "회계원리",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B104",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B104"
      }
    ]
  },
  "07661-008-2000763": {
    "name": "회계원리",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경B104",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경B104"
      }
    ]
  },
  "07686-001-2000506": {
    "name": "회계학연습",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수",
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "글경603",
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "글경603"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "글경607"
      }
    ]
  },
  "07818-001-2000740": {
    "name": "영어사들여다보기",
    "professor": "김현진",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "인문313",
    "meetings": [
      {
        "day": "화",
        "periods": [
          3,
          4
        ],
        "classroom": "인문313"
      },
      {
        "day": "목",
        "periods": [
          5
        ],
        "classroom": "인문313"
      }
    ]
  },
  "07826-001-2000618": {
    "name": "영어구문연습",
    "professor": "김현진",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "인문313",
    "meetings": [
      {
        "day": "화",
        "periods": [
          2
        ],
        "classroom": "인문313"
      },
      {
        "day": "목",
        "periods": [
          6,
          7
        ],
        "classroom": "인문313"
      }
    ]
  },
  "08011-001-2000297": {
    "name": "현대중국영화와소설",
    "professor": "고건혜",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "종합508",
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "종합508"
      }
    ]
  },
  "08105-001-2000639": {
    "name": "유한요소해석",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수",
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "종합506",
    "meetings": [
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "종합506"
      },
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "종합506"
      }
    ]
  },
  "08286-001-2000637": {
    "name": "오픈스페이스계획",
    "professor": "장남수",
    "credits": 3,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "08371-001-2000647": {
    "name": "시스템보안",
    "professor": "이지훈",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT307",
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT307"
      }
    ]
  },
  "08430-001-2000648": {
    "name": "체육행정관리",
    "professor": "이지선",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "체육116",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1
        ],
        "classroom": "체육116"
      },
      {
        "day": "금",
        "periods": [
          1,
          2
        ],
        "classroom": "체육116"
      }
    ]
  },
  "08484-001-2000603": {
    "name": "Digital Design2",
    "professor": "문정화",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술201",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술201"
      }
    ]
  },
  "08484-002-2000654": {
    "name": "Digital Design2",
    "professor": "문정화",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술202",
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술202"
      }
    ]
  },
  "08484-003-2000655": {
    "name": "Digital Design2",
    "professor": "서원",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술201",
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술201"
      }
    ]
  },
  "08484-005-2000603": {
    "name": "Digital Design2",
    "professor": "전지현",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술201",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술201"
      }
    ]
  },
  "08484-006-2000603": {
    "name": "Digital Design2",
    "professor": "한동석",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술202",
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술202"
      }
    ]
  },
  "08484-007-2000654": {
    "name": "Digital Design2",
    "professor": "임성경",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술202",
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술202"
      }
    ]
  },
  "08489-001-2000653": {
    "name": "기초타이포그래피",
    "professor": "정유섭",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술205",
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술205"
      }
    ]
  },
  "08489-002-2000653": {
    "name": "기초타이포그래피",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술213-2",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술213-2"
      }
    ]
  },
  "08491-001-2000653": {
    "name": "Editorial Design",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술213-2",
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술213-2"
      }
    ]
  },
  "08491-002-2000653": {
    "name": "Editorial Design",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술205",
    "meetings": [
      {
        "day": "목",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술205"
      }
    ]
  },
  "08504-001-2000653": {
    "name": "Motion Graphics",
    "professor": "조윤희",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술205",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술205"
      }
    ]
  },
  "08657-003-2000641": {
    "name": "전자회로2",
    "professor": "이철우",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합406",
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합406"
      }
    ]
  },
  "08705-002-2000639": {
    "name": "전산제도",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "자연대211",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "자연대211"
      }
    ]
  },
  "08714-001-2000642": {
    "name": "신소재공학특강1",
    "professor": "이성재",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수",
      "금"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "자연관407",
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "자연관407"
      },
      {
        "day": "금",
        "periods": [
          3
        ],
        "classroom": "자연관407"
      }
    ]
  },
  "08758-001-2000293": {
    "name": "BusinessEnglish",
    "professor": "니콜라스",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문301",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문301"
      }
    ]
  },
  "08832-001-2000614": {
    "name": "공연스텝실습2",
    "professor": "손정은",
    "credits": 1,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "복지B105",
    "meetings": [
      {
        "day": "월",
        "periods": [
          8,
          9
        ],
        "classroom": "복지B105"
      }
    ]
  },
  "08866-001-2000514": {
    "name": "자유전공",
    "professor": "정양구",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT415",
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT415"
      }
    ]
  },
  "09035-001-2000642": {
    "name": "고분자재료공정및설계",
    "professor": "정성은",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "자연관407",
    "meetings": [
      {
        "day": "월",
        "periods": [
          7
        ],
        "classroom": "자연관407"
      },
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "자연관407"
      }
    ]
  },
  "09067-002-2000654": {
    "name": "Pattern Design2",
    "professor": "강민정",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 5,
    "room": "종합B107",
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4,
          5
        ],
        "classroom": "종합B107"
      }
    ]
  },
  "09184-002-2000301": {
    "name": "정부규제론",
    "professor": "정하나",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문406",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문406"
      }
    ]
  },
  "09191-001-2000505": {
    "name": "윤리경영(경영)",
    "professor": "윤정권",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경607",
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경607"
      }
    ]
  },
  "09216-001-2000411": {
    "name": "토목구조물설계",
    "professor": "이주하",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "자연관506",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "자연관506"
      },
      {
        "day": "화",
        "periods": [
          3
        ],
        "classroom": "자연관506"
      }
    ]
  },
  "09561-002-2000598": {
    "name": "성인간호학실습2",
    "professor": "김라영",
    "credits": 2,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 9,
    "room": "미래416",
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          7,
          8,
          9
        ],
        "classroom": "미래416"
      }
    ]
  },
  "09564-002-2000598": {
    "name": "정신간호학1",
    "professor": "권민",
    "credits": 2,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래421",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "미래421"
      }
    ]
  },
  "09568-001-2000598": {
    "name": "모성간호학실습2",
    "professor": "박선아",
    "credits": 1,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래424",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래424"
      }
    ]
  },
  "09568-002-2000598": {
    "name": "모성간호학실습2",
    "professor": "안나영",
    "credits": 1,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래424",
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래424"
      }
    ]
  },
  "09666-001-2000431": {
    "name": "학교사회복지론",
    "professor": "윤은영",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "생활101",
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "생활101"
      }
    ]
  },
  "09676-001-2000432": {
    "name": "패션에디팅(그린패션디자인1)",
    "professor": "이동아",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "생활101",
    "meetings": [
      {
        "day": "월",
        "periods": [
          8,
          9
        ],
        "classroom": "생활101"
      },
      {
        "day": "목",
        "periods": [
          4
        ],
        "classroom": "생활302"
      }
    ]
  },
  "09756-001-2000624": {
    "name": "개발경제학1",
    "professor": "왕두균",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경503",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경503"
      }
    ]
  },
  "09756-002-2000625": {
    "name": "개발경제학1",
    "professor": "왕두균",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경503",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경503"
      }
    ]
  },
  "09778-001-2000658": {
    "name": "무의식과마음의대화",
    "professor": "이주향",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문507",
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문507"
      }
    ]
  },
  "09886-001-2000742": {
    "name": "중국지역문화특강",
    "professor": "송진영",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "인문301",
    "meetings": [
      {
        "day": "목",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "인문301"
      }
    ]
  },
  "09990-001-2000408": {
    "name": "바이오제약공학",
    "professor": "김준현",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "종합408",
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "종합408"
      },
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "종합410"
      }
    ]
  },
  "09991-001-2000408": {
    "name": "바이오향장공학",
    "professor": "김준현",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "종합408",
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3
        ],
        "classroom": "종합408"
      },
      {
        "day": "목",
        "periods": [
          3
        ],
        "classroom": "종합408"
      }
    ]
  },
  "09991-002-2000408": {
    "name": "바이오향장공학",
    "professor": "강성수",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "종합407",
    "meetings": [
      {
        "day": "화",
        "periods": [
          6
        ],
        "classroom": "종합407"
      },
      {
        "day": "금",
        "periods": [
          2,
          3
        ],
        "classroom": "종합407"
      }
    ]
  },
  "10014-001-2000598": {
    "name": "아동간호학실습2",
    "professor": "이경희",
    "credits": 1,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래424",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래424"
      }
    ]
  },
  "10014-002-2000598": {
    "name": "아동간호학실습2",
    "professor": "이경희",
    "credits": 1,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래424",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래424"
      }
    ]
  },
  "10022-001-2000430": {
    "name": "간호관리학실습",
    "professor": "차은정",
    "credits": 2,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 9,
    "room": "미래418",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          7,
          8,
          9
        ],
        "classroom": "미래418"
      }
    ]
  },
  "10031-001-2000430": {
    "name": "시뮬레이션통합실습",
    "professor": "박금주",
    "credits": 2,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미래427",
    "meetings": [
      {
        "day": "화",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미래427"
      }
    ]
  },
  "10031-002-2000430": {
    "name": "시뮬레이션통합실습",
    "professor": "이경희",
    "credits": 2,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미래427",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미래427"
      }
    ]
  },
  "10031-003-2000430": {
    "name": "시뮬레이션통합실습",
    "professor": "양정하",
    "credits": 2,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미래427",
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미래427"
      }
    ]
  },
  "10073-001-2000650": {
    "name": "운동건강관리",
    "professor": "한진희",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "체육116",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "체육116"
      }
    ]
  },
  "10173-001-2000658": {
    "name": "발명과특허",
    "professor": "김창회",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래520",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래520"
      }
    ]
  },
  "10220-002-2000598": {
    "name": "기본간호학실습2",
    "professor": "이예나",
    "credits": 1,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "미래420",
    "meetings": [
      {
        "day": "수",
        "periods": [
          8,
          9
        ],
        "classroom": "미래420"
      }
    ]
  },
  "10220-003-2000598": {
    "name": "기본간호학실습2",
    "professor": "이예나",
    "credits": 1,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "미래420",
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3
        ],
        "classroom": "미래420"
      }
    ]
  },
  "10220-004-2000598": {
    "name": "기본간호학실습2",
    "professor": "이예나",
    "credits": 1,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 5,
    "room": "미래420",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5
        ],
        "classroom": "미래420"
      }
    ]
  },
  "10259-001-2000618": {
    "name": "Topic Discussion2",
    "professor": "니콜라스",
    "credits": 3,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "10263-001-2000293": {
    "name": "Debate2",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "10274-001-2000297": {
    "name": "중국기업탐방과현장실습",
    "professor": "고건혜",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문501",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문501"
      }
    ]
  },
  "10320-001-2000605": {
    "name": "문화예술교육개론",
    "professor": "정상경",
    "credits": 2,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악315",
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "음악315"
      }
    ]
  },
  "10320-002-2000606": {
    "name": "문화예술교육개론",
    "professor": "정상경",
    "credits": 2,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악315",
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "음악315"
      }
    ]
  },
  "10320-003-2000607": {
    "name": "문화예술교육개론",
    "professor": "정상경",
    "credits": 2,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악315",
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "음악315"
      }
    ]
  },
  "10320-004-2000608": {
    "name": "문화예술교육개론",
    "professor": "정상경",
    "credits": 2,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악315",
    "meetings": [
      {
        "day": "금",
        "periods": [
          3,
          4
        ],
        "classroom": "음악315"
      }
    ]
  },
  "10355-001-2000629": {
    "name": "호텔관광경영전략",
    "professor": "마여실",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "글경703",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "글경703"
      },
      {
        "day": "화",
        "periods": [
          7
        ],
        "classroom": "글경703"
      }
    ]
  },
  "10380-001-2000411": {
    "name": "환경플랜트설계",
    "professor": "나정균",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합411",
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합411"
      }
    ]
  },
  "10381-001-2000414": {
    "name": "Presentation",
    "professor": "김현주",
    "credits": 1,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "2공학314",
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6
        ],
        "classroom": "2공학314"
      }
    ]
  },
  "10404-001-2000639": {
    "name": "동적시뮬레이션응용설계",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합506",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합506"
      }
    ]
  },
  "10421-001-2000635": {
    "name": "신재생에너지",
    "professor": "성기명",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 8,
    "endPeriod": 8,
    "room": "종합410",
    "meetings": [
      {
        "day": "월",
        "periods": [
          8
        ],
        "classroom": "종합410"
      },
      {
        "day": "목",
        "periods": [
          2,
          3
        ],
        "classroom": "종합410"
      }
    ]
  },
  "10422-001-2000635": {
    "name": "에너지자원과미래",
    "professor": "백영순",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래106",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래106"
      }
    ]
  },
  "10422-002-2000635": {
    "name": "에너지자원과미래",
    "professor": "박새롬",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수",
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "자연관307",
    "meetings": [
      {
        "day": "수",
        "periods": [
          3
        ],
        "classroom": "자연관307"
      },
      {
        "day": "월",
        "periods": [
          1,
          2
        ],
        "classroom": "종합404"
      }
    ]
  },
  "10433-001-2000651": {
    "name": "현대수묵화2",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형305",
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형305"
      }
    ]
  },
  "10436-001-2000651": {
    "name": "전통회화2",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "조형305",
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "조형305"
      }
    ]
  },
  "10448-001-2000653": {
    "name": "Design & Business",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술114",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술114"
      }
    ]
  },
  "10448-002-2000653": {
    "name": "Design & Business",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술114",
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술114"
      }
    ]
  },
  "10454-001-2000257": {
    "name": "Digital Media 2",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술208",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술208"
      }
    ]
  },
  "10487-001-2000517": {
    "name": "침해사고대응",
    "professor": "김종민",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "IT514",
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "IT514"
      }
    ]
  },
  "10487-002-2000517": {
    "name": "침해사고대응",
    "professor": "김종민",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "IT514",
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "IT514"
      }
    ]
  },
  "10549-001-2000637": {
    "name": "도시개발계획및실습",
    "professor": "안채완",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "종합510",
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "종합510"
      }
    ]
  },
  "10576-013-2000639": {
    "name": "캡스톤디자인1",
    "professor": "이찬",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연관309",
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연관309"
      }
    ]
  },
  "10576-018-2000654": {
    "name": "캡스톤디자인1(AI Fashion performance)",
    "professor": "전지현",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술213-1",
    "meetings": [
      {
        "day": "금",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술213-1"
      }
    ]
  },
  "10576-019-2000613": {
    "name": "캡스톤디자인1",
    "professor": "김석범",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "음악104",
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "음악104"
      }
    ]
  },
  "10577-004-2000408": {
    "name": "캡스톤디자인2",
    "professor": "최용복",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "종합404",
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "종합404"
      }
    ]
  },
  "10577-009-2000420": {
    "name": "캡스톤디자인2",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "종합412",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "종합412"
      }
    ]
  },
  "10577-017-2000435": {
    "name": "캡스톤디자인2",
    "professor": "이지선",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "체육114",
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "체육114"
      },
      {
        "day": "수",
        "periods": [
          4
        ],
        "classroom": "체육114"
      }
    ]
  },
  "10577-024-2000605": {
    "name": "캡스톤디자인2",
    "professor": "박영란",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "음악104",
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "음악104"
      }
    ]
  },
  "10577-027-2000608": {
    "name": "캡스톤디자인2",
    "professor": "에르완리샤",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "음악109",
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "음악109"
      }
    ]
  },
  "10603-001-2000642": {
    "name": "차세대탄소재료",
    "professor": "김창민",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "목"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "자연관407",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "자연관407"
      },
      {
        "day": "목",
        "periods": [
          7
        ],
        "classroom": "미래105"
      }
    ]
  },
  "10684-001-2000649": {
    "name": "레저스포츠투어리즘",
    "professor": "박지선",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래B202",
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래B202"
      }
    ]
  },
  "10728-001-2000257": {
    "name": "Portfolio 제작",
    "professor": "이수진",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술213-2",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술213-2"
      }
    ]
  },
  "10728-002-2000257": {
    "name": "Portfolio 제작",
    "professor": "이수진",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술213-2",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술213-2"
      }
    ]
  },
  "10939-001-2000658": {
    "name": "인성과삶의가치",
    "professor": "이정헌",
    "credits": 1,
    "isOnline": false,
    "days": [
      "토"
    ],
    "startPeriod": 15,
    "endPeriod": 15,
    "room": "종합408",
    "meetings": [
      {
        "day": "토",
        "periods": [
          15
        ],
        "classroom": "종합408"
      }
    ]
  },
  "10940-001-2000605": {
    "name": "융합캡스톤디자인",
    "professor": "권지원",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "음악105",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "음악105"
      }
    ]
  },
  "10940-002-2000606": {
    "name": "융합캡스톤디자인",
    "professor": "이현정",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "음악110",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "음악110"
      }
    ]
  },
  "10940-003-2000608": {
    "name": "융합캡스톤디자인",
    "professor": "김진환",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "음악109",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "음악109"
      }
    ]
  },
  "10940-004-2000759": {
    "name": "융합캡스톤디자인",
    "professor": "김대엽",
    "credits": 3,
    "isOnline": false,
    "days": [
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "IT306",
    "meetings": [
      {
        "day": "토",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "IT306"
      }
    ]
  },
  "10944-001-2000653": {
    "name": "Color&Design",
    "professor": "안희진",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술205",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술205"
      }
    ]
  },
  "10944-002-2000654": {
    "name": "Color&Design",
    "professor": "권지현",
    "credits": 2,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미술211",
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미술211"
      }
    ]
  },
  "10944-003-2000655": {
    "name": "Color&Design",
    "professor": "나미경",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "미술204",
    "meetings": [
      {
        "day": "수",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "미술204"
      }
    ]
  },
  "10944-004-2000653": {
    "name": "Color&Design",
    "professor": "안희진",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "미술205",
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "미술205"
      }
    ]
  },
  "10944-005-2000654": {
    "name": "Color&Design",
    "professor": "권지현",
    "credits": 2,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미술211",
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미술211"
      }
    ]
  },
  "10965-001-2000632": {
    "name": "단백질공학및실습2",
    "professor": "손영선",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "종합407",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6
        ],
        "classroom": "종합407"
      },
      {
        "day": "수",
        "periods": [
          8
        ],
        "classroom": "종합407"
      }
    ]
  },
  "10989-001-2000595": {
    "name": "빅데이터분석",
    "professor": "정진명",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경507",
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경507"
      }
    ]
  },
  "10989-002-2000595": {
    "name": "빅데이터분석",
    "professor": "정진명",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경507",
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경507"
      }
    ]
  },
  "11014-001-2000643": {
    "name": "화장품화학공학",
    "professor": "노호식",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "자연관408",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "자연관408"
      }
    ]
  },
  "11023-001-2000658": {
    "name": "과학문명사",
    "professor": "윤병국",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래B103",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래B103"
      }
    ]
  },
  "11030-002-2000658": {
    "name": "글로벌교양2(일본지역문화론)",
    "professor": "황준호",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래520",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래520"
      }
    ]
  },
  "11031-003-2000658": {
    "name": "글로벌교양3(이러닝_Gaming and Society)",
    "professor": "매튜",
    "credits": 3,
    "isOnline": true,
    "days": [
      "월",
      "토"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "인문508",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1
        ],
        "classroom": "인문508"
      },
      {
        "day": "토",
        "periods": [
          2,
          3
        ],
        "classroom": "인문508"
      }
    ]
  },
  "11034-005-2000658": {
    "name": "글로벌교양6(알렉산더테크닉(올바른몸사용법))",
    "professor": "최현철",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래110",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래110"
      }
    ]
  },
  "11066-001-2000658": {
    "name": "생활속의과학원리",
    "professor": "김충섭",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래110",
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래110"
      }
    ]
  },
  "11090-001-2000658": {
    "name": "영화와여성이미지",
    "professor": "박소연",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래B106",
    "meetings": [
      {
        "day": "목",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래B106"
      }
    ]
  },
  "11107-001-2000658": {
    "name": "재난의과학적이해",
    "professor": "김영출",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "미래B106",
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "미래B106"
      }
    ]
  },
  "11141-001-2000642": {
    "name": "생활속의고분자",
    "professor": "장건수",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래104",
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래104"
      },
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "미래319"
      }
    ]
  },
  "11141-001-2000763": {
    "name": "생활속의고분자",
    "professor": "장건수",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 6,
    "room": "미래104",
    "meetings": [
      {
        "day": "화",
        "periods": [
          5,
          6
        ],
        "classroom": "미래104"
      },
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "미래319"
      }
    ]
  },
  "11144-001-2000642": {
    "name": "고분자표면및계면",
    "professor": "박준수",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "종합403",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "종합403"
      },
      {
        "day": "목",
        "periods": [
          1
        ],
        "classroom": "종합403"
      }
    ]
  },
  "11160-001-2000658": {
    "name": "허브식물학",
    "professor": "오사다사치코",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "생활101",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "생활101"
      }
    ]
  },
  "11160-002-2000658": {
    "name": "허브식물학",
    "professor": "오사다사치코",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "생활101",
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "생활101"
      }
    ]
  },
  "11221-001-2000658": {
    "name": "4차산업혁명과미래",
    "professor": "윤영석",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "종합609",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "종합609"
      }
    ]
  },
  "11223-001-2000653": {
    "name": "Digital Design3",
    "professor": "조윤희",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "미술213-1",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "미술213-1"
      }
    ]
  },
  "11223-002-2000653": {
    "name": "Digital Design3",
    "professor": "전성재",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "생활108",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "생활108"
      }
    ]
  },
  "11240-001-2000606": {
    "name": "가곡앙상블2",
    "professor": "이명국",
    "credits": 2,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악105",
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4
        ],
        "classroom": "음악105"
      }
    ]
  },
  "11281-001-2000590": {
    "name": "디자인이해2",
    "professor": "권경남",
    "credits": 4,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학304",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학304"
      }
    ]
  },
  "11281-002-2000590": {
    "name": "디자인이해2",
    "professor": "김유라",
    "credits": 4,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 7,
    "room": "2공학206",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3,
          5,
          6,
          7
        ],
        "classroom": "2공학206"
      }
    ]
  },
  "11292-002-2000418": {
    "name": "로봇공학",
    "professor": "임동원",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 6,
    "endPeriod": 7,
    "room": "자연관309",
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7
        ],
        "classroom": "자연관309"
      },
      {
        "day": "화",
        "periods": [
          6
        ],
        "classroom": "종합405"
      }
    ]
  },
  "11308-001-2000264": {
    "name": "문화예술창업론",
    "professor": "박재현",
    "credits": 2,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악103",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악103"
      }
    ]
  },
  "11308-002-2000265": {
    "name": "문화예술창업론",
    "professor": "박재현",
    "credits": 2,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악103",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악103"
      }
    ]
  },
  "11308-003-2000267": {
    "name": "문화예술창업론",
    "professor": "박재현",
    "credits": 2,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악103",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악103"
      }
    ]
  },
  "11308-004-2000276": {
    "name": "문화예술창업론",
    "professor": "박재현",
    "credits": 2,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악103",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악103"
      }
    ]
  },
  "11308-005-2000277": {
    "name": "문화예술창업론",
    "professor": "박재현",
    "credits": 2,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 2,
    "room": "음악103",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2
        ],
        "classroom": "음악103"
      }
    ]
  },
  "11310-001-2000655": {
    "name": "물레성형2",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 3,
    "endPeriod": 5,
    "room": "조형103",
    "meetings": [
      {
        "day": "목",
        "periods": [
          3,
          4,
          5
        ],
        "classroom": "조형103"
      }
    ]
  },
  "11315-001-2000658": {
    "name": "발달주기와생애설계",
    "professor": "김수지",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "종합307",
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "종합307"
      }
    ]
  },
  "11371-001-2000277": {
    "name": "연주캡스톤(관현악)",
    "professor": "김영은",
    "credits": 1,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "음악217",
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "음악217"
      }
    ]
  },
  "11372-001-2000267": {
    "name": "연주캡스톤(국악)",
    "professor": "박혜진",
    "credits": 1,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "음악107",
    "meetings": [
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "음악107"
      }
    ]
  },
  "11382-001-2000613": {
    "name": "영화분석세미나",
    "professor": "김동윤",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "복지203",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "복지203"
      }
    ]
  },
  "11416-002-2000586": {
    "name": "전공진로세미나2(회계)",
    "professor": "",
    "credits": 1,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 7,
    "room": "글경503",
    "meetings": [
      {
        "day": "수",
        "periods": [
          7
        ],
        "classroom": "글경503"
      }
    ]
  },
  "11416-008-2000604": {
    "name": "전공진로세미나2",
    "professor": "권지현",
    "credits": 1,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 1,
    "room": "미술114",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1
        ],
        "classroom": "미술114"
      }
    ]
  },
  "11416-012-2000608": {
    "name": "전공진로세미나2",
    "professor": "김수진",
    "credits": 1,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "음악216",
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "음악216"
      }
    ]
  },
  "11417-005-2000584": {
    "name": "전공진로세미나3",
    "professor": "정요안",
    "credits": 1,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 6,
    "room": "인문107",
    "meetings": [
      {
        "day": "수",
        "periods": [
          6
        ],
        "classroom": "인문107"
      }
    ]
  },
  "11417-015-2000606": {
    "name": "전공진로세미나3",
    "professor": "이현정",
    "credits": 1,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 4,
    "room": "음악110",
    "meetings": [
      {
        "day": "금",
        "periods": [
          4
        ],
        "classroom": "음악110"
      }
    ]
  },
  "11417-034-2000604": {
    "name": "전공진로세미나3",
    "professor": "이의정",
    "credits": 1,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 5,
    "room": "미술102",
    "meetings": [
      {
        "day": "수",
        "periods": [
          5
        ],
        "classroom": "미술102"
      }
    ]
  },
  "11417-037-2000580": {
    "name": "전공진로세미나3(국어국문학)",
    "professor": "문현수",
    "credits": 1,
    "isOnline": false,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "11420-001-2000624": {
    "name": "정치경제학",
    "professor": "윤면식",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경501",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경501"
      }
    ]
  },
  "11450-001-2000613": {
    "name": "프로덕션피치크리틱1",
    "professor": "이상노",
    "credits": 1,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 10,
    "endPeriod": 10,
    "room": "글경101",
    "meetings": [
      {
        "day": "금",
        "periods": [
          10
        ],
        "classroom": "글경101"
      }
    ]
  },
  "11452-001-2000613": {
    "name": "프로덕션피치크리틱3",
    "professor": "김계중",
    "credits": 1,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 10,
    "endPeriod": 10,
    "room": "글경101",
    "meetings": [
      {
        "day": "금",
        "periods": [
          10
        ],
        "classroom": "글경101"
      }
    ]
  },
  "11499-001-2000658": {
    "name": "일.사랑.행복",
    "professor": "김지송",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경101",
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경101"
      }
    ]
  },
  "11511-001-2000715": {
    "name": "고체전자공학",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "첨단109",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "첨단109"
      }
    ]
  },
  "11519-001-2000553": {
    "name": "집적회로설계실습",
    "professor": "윤보열",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 4,
    "room": "2공학115",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3,
          4
        ],
        "classroom": "2공학115"
      }
    ]
  },
  "11532-001-2000595": {
    "name": "라이프케어빅데이터분석",
    "professor": "염희란",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경507",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경507"
      }
    ]
  },
  "11532-002-2000595": {
    "name": "라이프케어빅데이터분석",
    "professor": "염희란",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경507",
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경507"
      }
    ]
  },
  "11535-001-2000625": {
    "name": "World Culture and Travel English",
    "professor": "딜런",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목",
      "화"
    ],
    "startPeriod": 2,
    "endPeriod": 2,
    "room": "글경504",
    "meetings": [
      {
        "day": "목",
        "periods": [
          2
        ],
        "classroom": "글경504"
      },
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": ""
      }
    ]
  },
  "11558-001-2000716": {
    "name": "스타트업마케팅전략",
    "professor": "최종학",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래521",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래521"
      }
    ]
  },
  "11558-002-2000716": {
    "name": "스타트업마케팅전략",
    "professor": "최종학",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래521",
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래521"
      }
    ]
  },
  "11571-001-2000658": {
    "name": "중국도시랜선여행",
    "professor": "손미리",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "종합506",
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "종합506"
      }
    ]
  },
  "11585-001-2000587": {
    "name": "로컬콘텐츠와해양레저관광",
    "professor": "김승준",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "글경701",
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "글경701"
      }
    ]
  },
  "11599-001-2000180": {
    "name": "전동화시스템및실험",
    "professor": "배진용",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "자연관509",
    "meetings": [
      {
        "day": "수",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "자연관509"
      }
    ]
  },
  "11611-001-2000658": {
    "name": "그린리더십산업의발견",
    "professor": "류덕기",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "글경B104",
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "글경B104"
      }
    ]
  },
  "11619-001-2000658": {
    "name": "로컬콘텐츠와창업",
    "professor": "한승헌",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래520",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래520"
      }
    ]
  },
  "11633-002-2000598": {
    "name": "인체구조와기능",
    "professor": "최고은",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 5,
    "endPeriod": 7,
    "room": "미래417",
    "meetings": [
      {
        "day": "금",
        "periods": [
          5,
          6,
          7
        ],
        "classroom": "미래417"
      }
    ]
  },
  "11638-001-2000615": {
    "name": "로컬메이커2",
    "professor": "주명진",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "미래116",
    "meetings": [
      {
        "day": "월",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "미래116"
      }
    ]
  },
  "11647-001-2000592": {
    "name": "나노소재과학2",
    "professor": "이관",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월",
      "수"
    ],
    "startPeriod": 3,
    "endPeriod": 3,
    "room": "종합302",
    "meetings": [
      {
        "day": "월",
        "periods": [
          3
        ],
        "classroom": "종합302"
      },
      {
        "day": "수",
        "periods": [
          1,
          2
        ],
        "classroom": "종합408"
      }
    ]
  },
  "11683-001-2000748": {
    "name": "소방방재개론",
    "professor": "권설아",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 8,
    "room": "인문506",
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8
        ],
        "classroom": "인문506"
      }
    ]
  },
  "11703-001-2000598": {
    "name": "정신간호학실습1",
    "professor": "권민",
    "credits": 2,
    "isOnline": false,
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "미래416",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래416"
      },
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "미래416"
      }
    ]
  },
  "11703-002-2000598": {
    "name": "정신간호학실습1",
    "professor": "이은미",
    "credits": 2,
    "isOnline": false,
    "days": [
      "월",
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "미래416",
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래416"
      },
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "미래416"
      }
    ]
  },
  "11714-001-2000655": {
    "name": "Ceramic & Material Studies2",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 2,
    "endPeriod": 4,
    "room": "조형103",
    "meetings": [
      {
        "day": "월",
        "periods": [
          2,
          3,
          4
        ],
        "classroom": "조형103"
      }
    ]
  },
  "11729-001-2000257": {
    "name": "3D Graphic Studio",
    "professor": "",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 5,
    "endPeriod": 8,
    "room": "미술213-1",
    "meetings": [
      {
        "day": "월",
        "periods": [
          5,
          6,
          7,
          8
        ],
        "classroom": "미술213-1"
      }
    ]
  },
  "11755-001-2000742": {
    "name": "AI활용중국어작문연습",
    "professor": "최영",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화",
      "목"
    ],
    "startPeriod": 2,
    "endPeriod": 3,
    "room": "인문500",
    "meetings": [
      {
        "day": "화",
        "periods": [
          2,
          3
        ],
        "classroom": "인문500"
      },
      {
        "day": "목",
        "periods": [
          7
        ],
        "classroom": "인문501"
      }
    ]
  },
  "11785-001-2000760": {
    "name": "비즈니스영어",
    "professor": "사무엘",
    "credits": 2,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 8,
    "endPeriod": 9,
    "room": "국제309",
    "meetings": [
      {
        "day": "월",
        "periods": [
          8,
          9
        ],
        "classroom": "국제309"
      }
    ]
  },
  "11789-004-2000763": {
    "name": "AI활용ESL2",
    "professor": "유정화(소피)",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문312",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문312"
      }
    ]
  },
  "11789-006-2000763": {
    "name": "AI활용ESL2",
    "professor": "코스민",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문305",
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문305"
      }
    ]
  },
  "11789-010-2000738": {
    "name": "AI활용ESL2",
    "professor": "레라니",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문305",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문305"
      }
    ]
  },
  "11789-014-2000738": {
    "name": "AI활용ESL2",
    "professor": "크리스",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문305",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문305"
      }
    ]
  },
  "11789-018-2000738": {
    "name": "AI활용ESL2",
    "professor": "코스민",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문305",
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문305"
      }
    ]
  },
  "11789-023-2000754": {
    "name": "AI활용ESL2",
    "professor": "제임",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문405",
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문405"
      }
    ]
  },
  "11789-024-2000754": {
    "name": "AI활용ESL2",
    "professor": "사무엘",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문306",
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문306"
      }
    ]
  },
  "11789-025-2000754": {
    "name": "AI활용ESL2",
    "professor": "로레타",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문312",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문312"
      }
    ]
  },
  "11789-032-2000589": {
    "name": "AI활용ESL2",
    "professor": "지나인",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문311",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문311"
      }
    ]
  },
  "11789-037-2000590": {
    "name": "AI활용ESL2",
    "professor": "스리비디아",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문305",
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문305"
      }
    ]
  },
  "11789-039-2000756": {
    "name": "AI활용ESL2",
    "professor": "최수연(줄리)",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문405",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문405"
      }
    ]
  },
  "11789-045-2000593": {
    "name": "AI활용ESL2",
    "professor": "재스민",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문305",
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문305"
      }
    ]
  },
  "11789-046-2000593": {
    "name": "AI활용ESL2",
    "professor": "유젤",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문311",
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문311"
      }
    ]
  },
  "11789-051-2000594": {
    "name": "AI활용ESL2",
    "professor": "최수연(줄리)",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문305",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문305"
      }
    ]
  },
  "11789-056-2000757": {
    "name": "AI활용ESL2",
    "professor": "도미닉",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문405",
    "meetings": [
      {
        "day": "목",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문405"
      }
    ]
  },
  "11789-060-2000758": {
    "name": "AI활용ESL2",
    "professor": "지나인",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문405",
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문405"
      }
    ]
  },
  "11789-065-2000598": {
    "name": "AI활용ESL2",
    "professor": "딜런",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문305",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문305"
      }
    ]
  },
  "11789-068-2000599": {
    "name": "AI활용ESL2",
    "professor": "재스민",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문405",
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문405"
      }
    ]
  },
  "11789-070-2000600": {
    "name": "AI활용ESL2",
    "professor": "데이비드던",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문405",
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문405"
      }
    ]
  },
  "11789-073-2000601": {
    "name": "AI활용ESL2",
    "professor": "알미라",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문311",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문311"
      }
    ]
  },
  "11789-074-2000602": {
    "name": "AI활용ESL2",
    "professor": "이선영",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문502",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문502"
      }
    ]
  },
  "11789-076-2000602": {
    "name": "AI활용ESL2",
    "professor": "알미라",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문504",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문504"
      }
    ]
  },
  "11789-080-2000603": {
    "name": "AI활용ESL2",
    "professor": "쉐인",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문504",
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문504"
      }
    ]
  },
  "11789-084-2000654": {
    "name": "AI활용ESL2",
    "professor": "토드",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문311",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문311"
      }
    ]
  },
  "11789-085-2000655": {
    "name": "AI활용ESL2",
    "professor": "션",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문312",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문312"
      }
    ]
  },
  "11789-088-2000607": {
    "name": "AI활용ESL2",
    "professor": "제프리",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문502",
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문502"
      }
    ]
  },
  "11789-089-2000607": {
    "name": "AI활용ESL2",
    "professor": "이선영",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문503",
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문503"
      }
    ]
  },
  "11789-090-2000608": {
    "name": "AI활용ESL2",
    "professor": "재스민",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문305",
    "meetings": [
      {
        "day": "금",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문305"
      }
    ]
  },
  "11789-095-2000615": {
    "name": "AI활용ESL2",
    "professor": "노디아",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문504",
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문504"
      }
    ]
  },
  "11789-096-2000658": {
    "name": "AI활용ESL2(재수강)",
    "professor": "조니",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문312",
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문312"
      }
    ]
  },
  "11791-002-2000763": {
    "name": "AI활용CSL2",
    "professor": "김화",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문311",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문311"
      }
    ]
  },
  "11791-004-2000763": {
    "name": "AI활용CSL2",
    "professor": "김연희",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문502",
    "meetings": [
      {
        "day": "수",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문502"
      }
    ]
  },
  "11791-006-2000763": {
    "name": "AI활용CSL2",
    "professor": "박신순",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문311",
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문311"
      }
    ]
  },
  "11791-007-2000763": {
    "name": "AI활용CSL2",
    "professor": "고건혁",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문312",
    "meetings": [
      {
        "day": "수",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문312"
      }
    ]
  },
  "11791-009-2000738": {
    "name": "AI활용CSL2",
    "professor": "조려연",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문311",
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문311"
      }
    ]
  },
  "11791-010-2000738": {
    "name": "AI활용CSL2",
    "professor": "박신순",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문312",
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문312"
      }
    ]
  },
  "11791-011-2000738": {
    "name": "AI활용CSL2",
    "professor": "이계정",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문510",
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문510"
      }
    ]
  },
  "11791-013-2000738": {
    "name": "AI활용CSL2",
    "professor": "손양",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문510",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문510"
      }
    ]
  },
  "11791-014-2000738": {
    "name": "AI활용CSL2",
    "professor": "장수",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문511",
    "meetings": [
      {
        "day": "화",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문511"
      }
    ]
  },
  "11791-015-2000738": {
    "name": "AI활용CSL2",
    "professor": "얀준",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문510",
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문510"
      }
    ]
  },
  "11791-016-2000738": {
    "name": "AI활용CSL2",
    "professor": "손양",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문511",
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문511"
      }
    ]
  },
  "11791-019-2000754": {
    "name": "AI활용CSL2",
    "professor": "고춘화",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문511",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문511"
      }
    ]
  },
  "11791-020-2000754": {
    "name": "AI활용CSL2",
    "professor": "수우죽",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문510",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문510"
      }
    ]
  },
  "11791-021-2000754": {
    "name": "AI활용CSL2",
    "professor": "이계정",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문511",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문511"
      }
    ]
  },
  "11791-025-2000754": {
    "name": "AI활용CSL2",
    "professor": "김화",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문405",
    "meetings": [
      {
        "day": "수",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문405"
      }
    ]
  },
  "11791-032-2000598": {
    "name": "AI활용CSL2",
    "professor": "이계정",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문504",
    "meetings": [
      {
        "day": "목",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문504"
      }
    ]
  },
  "11791-034-2000599": {
    "name": "AI활용CSL2",
    "professor": "황지군",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문312",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문312"
      }
    ]
  },
  "11791-041-2000602": {
    "name": "AI활용CSL2",
    "professor": "박신순",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문311",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문311"
      }
    ]
  },
  "11791-042-2000602": {
    "name": "AI활용CSL2",
    "professor": "장정",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문312",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문312"
      }
    ]
  },
  "11791-046-2000603": {
    "name": "AI활용CSL2",
    "professor": "조려연",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문305",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문305"
      }
    ]
  },
  "11791-049-2000653": {
    "name": "AI활용CSL2",
    "professor": "왕치엔",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문405",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문405"
      }
    ]
  },
  "11791-054-2000607": {
    "name": "AI활용CSL2",
    "professor": "조려연",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문311",
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문311"
      }
    ]
  },
  "11791-055-2000607": {
    "name": "AI활용CSL2",
    "professor": "맹춘영",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "인문312",
    "meetings": [
      {
        "day": "화",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "인문312"
      }
    ]
  },
  "11791-057-2000608": {
    "name": "AI활용CSL2",
    "professor": "고춘화",
    "credits": 3,
    "isOnline": false,
    "days": [
      "금"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문405",
    "meetings": [
      {
        "day": "금",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문405"
      }
    ]
  },
  "11791-058-2000609": {
    "name": "AI활용CSL2",
    "professor": "얀준",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 4,
    "endPeriod": 6,
    "room": "인문305",
    "meetings": [
      {
        "day": "월",
        "periods": [
          4,
          5,
          6
        ],
        "classroom": "인문305"
      }
    ]
  },
  "11791-059-2000613": {
    "name": "AI활용CSL2",
    "professor": "수우죽",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문502",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문502"
      }
    ]
  },
  "11791-061-2000615": {
    "name": "AI활용CSL2",
    "professor": "김화",
    "credits": 3,
    "isOnline": false,
    "days": [
      "화"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "인문504",
    "meetings": [
      {
        "day": "화",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "인문504"
      }
    ]
  },
  "11793-026-2000609": {
    "name": "AI리터러시(이러닝)",
    "professor": "교양대학",
    "credits": 3,
    "isOnline": true,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "11793-027-2000610": {
    "name": "AI리터러시(이러닝)",
    "professor": "교양대학",
    "credits": 3,
    "isOnline": true,
    "days": [],
    "startPeriod": null,
    "endPeriod": null,
    "room": "",
    "meetings": []
  },
  "12436-006-2000754": {
    "name": "글로벌비즈니스론",
    "professor": "류덕기",
    "credits": 3,
    "isOnline": false,
    "days": [
      "목"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "글경602",
    "meetings": [
      {
        "day": "목",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "글경602"
      }
    ]
  },
  "12436-007-2000754": {
    "name": "글로벌비즈니스론(재수강반_이러닝)",
    "professor": "윤성원",
    "credits": 3,
    "isOnline": true,
    "days": [
      "화",
      "토"
    ],
    "startPeriod": 9,
    "endPeriod": 9,
    "room": "글경607",
    "meetings": [
      {
        "day": "화",
        "periods": [
          9
        ],
        "classroom": "글경607"
      },
      {
        "day": "토",
        "periods": [
          5,
          6
        ],
        "classroom": "글경607"
      }
    ]
  },
  "12521-001-2000608": {
    "name": "서양음악기초이론통법2",
    "professor": "김예지",
    "credits": 2,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 3,
    "endPeriod": 4,
    "room": "음악103",
    "meetings": [
      {
        "day": "월",
        "periods": [
          3,
          4
        ],
        "classroom": "음악103"
      }
    ]
  },
  "12530-001-2000608": {
    "name": "무대음향이론",
    "professor": "서순정",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 1,
    "endPeriod": 3,
    "room": "음악222",
    "meetings": [
      {
        "day": "월",
        "periods": [
          1,
          2,
          3
        ],
        "classroom": "음악222"
      }
    ]
  },
  "12730-001-2000658": {
    "name": "캠퍼스합창",
    "professor": "전은배",
    "credits": 3,
    "isOnline": false,
    "days": [
      "월"
    ],
    "startPeriod": 7,
    "endPeriod": 9,
    "room": "음악111",
    "meetings": [
      {
        "day": "월",
        "periods": [
          7,
          8,
          9
        ],
        "classroom": "음악111"
      }
    ]
  },
  "12749-002-2000654": {
    "name": "Basic Sewing Techniques ",
    "professor": "이민정",
    "credits": 3,
    "isOnline": false,
    "days": [
      "수"
    ],
    "startPeriod": 6,
    "endPeriod": 9,
    "room": "종합B107",
    "meetings": [
      {
        "day": "수",
        "periods": [
          6,
          7,
          8,
          9
        ],
        "classroom": "종합B107"
      }
    ]
  }
}
